import React from "react";
import Loader from 'react-loader-spinner'
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import Modal from "../Modal";
import ButtonAnimated from "../buttons/ButtonAnimated";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

class RegionsInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        countryStatesSummery: {},
        countryStates: {},
        isLoadingStates: {},
        states: [],
        tempSelectedStates: null

    }

    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen

        if (openState) {
            // document.addEventListener('mousedown', this.fixedView.hideView);
            // window.addEventListener('scroll', this.fixedView.showView, true);
            // this.getPosition()
            if (this.fixedView)
                this.fixedView.showView()

        } else {
            // document.removeEventListener('mousedown', this.fixedView.hideView);
            // window.removeEventListener('scroll', this.fixedView.showView);
            this.fixedView.hideView()


        }


        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);
            // this.refs.icon.classList.toggle("rotate-180")
        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }


    changeItem = (prop, selected, dontChangeValue, dontOpen) => {

        // console.log("CHANGE")
        let choosen = this.state.choosen


        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })


        if (selected) {
            for (let i = 0; i < choosen.length; i++) {

                if (choosen[i].value == prop.value) {
                    choosen.splice(i, 1)
                }
            }
        } else {
            this.fetchStates([prop.country])
            if (this.props.header?.information?.singleCountry) {
                choosen = []
            }
            choosen.push(prop)
        }

        this.setState({ choosen }, () => {
            if (!dontChangeValue) this.changeValue()
        })

        setTimeout(() => {
            if (!dontOpen) {
                this.toggleOpen(true)
            }
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.data)

        if (prevProps.data != this.props.data && this.mounted) {
            this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {
        if (this.props.header.information) {
            // if (this.props.header.information.type == "local") {

            //     let options = []
            //     let choosen = []

            //     if (this.props.header.information.items && this.props.header.information.items.length > 0) {
            //         options = this.props.header.information.items
            //     }

            //     if (this.props.title && Array.isArray(this.props.title)) {
            //         this.props.title.forEach(element => {
            //             choosen.push({ title: element, value: element })
            //         });
            //     }
            //     // console.log(this.props.title)
            //     this.setState({ options, choosen })
            // } else if (this.props.header.information.type == "api") {
            // console.log(this.props.title)
            this.fetch()
            // }
        }
    }


    fetch() {


        this.setState({ isLoading: true })
        let address = this.props.header.information.address
        let filter = typeof this.props.header.information.filter == "string" ? JSON.parse(this.props.header.information.filter) : this.props.header.information.filter

        if (filter && typeof filter == 'object') {
            for (const [key, value] of Object.entries(filter)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
        }
        // console.log(filter)
        // console.log(address)


        HttpService.request(address, filter, (fetchResult, fetchError) => {
            // console.log(fetchError)
            if (fetchError) { return }

            // console.log(fetchResult)
            // fetch(address, {
            //     method: 'POST',
            //     body: JSON.stringify(filter),
            //     headers: headers
            // }).then(response => response.json()).then(data => {
            // console.log(data)
            // if (data.status == 200 && this.mounted) {
            var newData = []
            fetchResult.info.forEach(element => {

                let myData = {}
                Object.entries(this.props.header.information.fields)?.map(([key, value]) => {
                    myData[key] = getObject(element, value)
                })
                // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                // var newValue = this.spliter(element, this.props.header.information.fields.value)

                newData.push(myData)
                // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                // var newValue = this.spliter(element, this.props.header.information.fields.value)

                // newData.push({ value: newValue, title: newTitle })
            });

            // console.log(this.props.data)

            let countriesToFetchStates = []

            if (Array.isArray(this.props.data)) {
                let choosen = []
                this.props.data.forEach(oneTitle => {

                    // console.log(oneTitle)

                    let oneTitleId = typeof oneTitle.country == 'object' ? oneTitle?.country._id : oneTitle.country

                    // console.log(oneTitleId)

                    newData.forEach(oneNewData => {

                        if (oneNewData.country == oneTitleId) {
                            let myData = {}
                            Object.entries(this.props.header.information.fields)?.map(([key, value]) => {
                                myData[key] = getObject(oneNewData, key)
                            })

                            countriesToFetchStates.push(oneTitleId)

                            myData.states = getObject(oneTitle, 'states')
                            choosen.push(myData)
                        }
                    });

                })

                // console.log(choosen)

                this.setState({ choosen }, () => {
                    this.fetchStates(countriesToFetchStates)
                })
                // console.log(choosen)


            }

            this.setState({
                options: newData,
                isLoading: false
            })
        })

        // }).catch(error => this.setState({ error, isLoading: false }));
    }






    fetchStates(countries) {

        let isLoadingStates = { ...this.state.isLoadingStates }


        // console.log("fetchStates",countries)
        if (Array.isArray(countries)) {

            let myCountries = []
            countries.forEach(country => {
                isLoadingStates[country] = true
                if (!this.state.countryStates[country]) {
                    myCountries.push(country)
                }
            });

            if (myCountries.length > 0) {
                this.setState({ isLoadingStates: isLoadingStates })

                let address = 'getStates'
                let filter = { country: myCountries }


                HttpService.request(address, filter, (fetchResult, fetchError) => {

                    countries.forEach(country => {
                        isLoadingStates[country] = false
                    });


                    if (fetchError) { return }


                    let newData = []
                    let countryStatesSummery = this.state.countryStatesSummery
                    let countryStates = this.state.countryStates


                    myCountries.forEach(country => {


                        countryStates[country] = []
                        let statesCount = 0
                        let stateTypes = []

                        fetchResult.info.forEach(state => {


                            let id = typeof state.country == 'object' ? state.country?._id : state.country
                            let choosens = this.state.choosen


                            let choosen
                            if (Array.isArray(choosens)) {
                                choosens.forEach(element => {
                                    if (element.country == id) {
                                        choosen = element
                                    }
                                });
                            }


                            if (country == id) {
                                countryStates[country].push(state)

                                let shouldInclude = false

                                if (!choosen?.states || Object.keys(choosen?.states).length == 0) {
                                    shouldInclude = true
                                }

                                if (!shouldInclude && Array.isArray(choosen?.states)) {

                                    choosen?.states.forEach(mState => {
                                        let mId = typeof mState == 'object' ? mState?._id : mState
                                        if (mId == state._id) {
                                            shouldInclude = true
                                        }
                                    });
                                    // choosen?.states.includes(state._id)
                                }

                                if (shouldInclude) {
                                    statesCount = statesCount + 1

                                    let type = this.createCountryStateText(state.type)
                                    if (!stateTypes.includes(type)) {
                                        stateTypes.push(type)
                                    }
                                }
                            }
                        })
                        let countryText = statesCount + ' ' + stateTypes.join(' / ')
                        countryStatesSummery[country] = { count: statesCount, types: stateTypes, text: countryText }
                    })




                    let states = this.state.states
                    states = [...states, ...fetchResult.info]

                    // console.log(countryStates)

                    this.setState({ states: states, countryStates, countryStatesSummery, isLoadingStates: isLoadingStates })
                })
            }

        }

    }




    createCountryStateText(stateType) {

        let type = stateType

        switch (String(type).toLowerCase()) {
            case 'null':
                type = 'Provinces'
                break;

            case 'undefined':
                type = 'Provinces'
                break;


            case 'true':
                type = 'Provinces'
                break;

            case 'province':
                type = 'Provinces'
                break;

            case 'state':
                type = 'States'
                break;


            case 'territory':
                type = 'territories'
                break;

            default:
                break;
        }

        return type

    }

    // spliter(source, string) {
    //     var stringArray = string.split('.')
    //     var finalString = source
    //     stringArray.forEach(element => {
    //         finalString = finalString[element]
    //     });
    //     return finalString
    // }


    // conditionalSettings(param, condition) {
    //     if (this.props.settings) {
    //         if (this.props.settings[param] == condition) {
    //             return true
    //         }
    //     }
    //     return false
    // }


    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }


    removeItem(index) {
        let choosen = [...this.state.choosen]
        choosen.splice(index, 1)
        this.setState({ choosen }, () => {
            this.changeValue()
        })
    }


    addTag() {
        let tempData = [...this.state.tempData]
        let choosen = [...this.state.choosen]

        let item = { title: this.state.title, value: this.state.title }
        tempData.push(item)
        // choosen.push(item)
        this.setState({ tempData }, () => {
            this.changeItem(item, false)
        })
        this.refs.input.focus()
    }

    changeValue() {
        let choosen = []

        // console.log(choosen)
        this.state.choosen.forEach(element => {
            choosen.push({ country: element.country, states: element.states })
            // choosen.push((element.value))

        });
        // console.log(choosen)
        this.props.changeValue(this.props.header.key, choosen, this.props.extra)
    }

    openStates = (e, prop) => {
        e.stopPropagation()
        let tempSelectedStates = {}


        this.setState({ currentCountry: prop }, () => {


            if (prop.states == null || Object.keys(prop.states).length == 0) {

                this.selectAllTempStates()

            } else {

                // console.log(prop.states)

                if (Array.isArray(prop.states)) {
                    prop.states.forEach(state => {
                        let id = typeof state == 'object' ? state._id : state
                        tempSelectedStates[id] = true
                    });
                }

                this.setState({ tempSelectedStates }, () => { })

            }


            this.statesModal.showModal()
        })
    }

    changeCurrentTempStates = (state, selected) => {
        let tempSelectedStates = this.state.tempSelectedStates
        if (!tempSelectedStates) {
            tempSelectedStates = {}
        }
        if (selected) {
            delete tempSelectedStates[state._id]
        } else {
            tempSelectedStates[state._id] = true
        }

        this.setState({ tempSelectedStates })
    }


    submitCurrentStates = () => {

        let result
        let tempSelectedStates = this.state.tempSelectedStates
        let choosen = this.state.choosen
        let statesCount = 0
        let stateTypes = []
        let currentCountry = this.state.currentCountry
        let countryStates = this.state.countryStates[currentCountry?.country]


        if (this.state.tempSelectedStates) {

            let keysLength = Object.keys(tempSelectedStates).length

            if (keysLength == 0) {

                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Data is not sufficient', description: '{{lang}}At least one region needs to be selected.' })
                return
            } else {


                if (keysLength != countryStates?.length) {

                    result = []
                    Object.keys(tempSelectedStates).forEach(state => {
                        result.push(state)
                        statesCount = statesCount + 1

                        countryStates.forEach(element => {
                            if (element._id == state) {
                                let type = this.createCountryStateText(element.type)
                                if (!stateTypes.includes(type)) {
                                    stateTypes.push(type)
                                }
                            }
                        });
                    })

                } else {

                    countryStates.forEach(element => {

                        statesCount = statesCount + 1
                        let type = this.createCountryStateText(element.type)
                        if (!stateTypes.includes(type)) {
                            stateTypes.push(type)
                        }

                    })

                }

                choosen.forEach((element, index) => {
                    if (element.country == currentCountry.country) {
                        choosen[index].states = result
                    }
                });

                // console.log(choosen)

                let countryStatesSummery = this.state.countryStatesSummery
                let countryText = statesCount + ' ' + stateTypes.join(' / ')
                countryStatesSummery[currentCountry?.country] = { count: statesCount, types: stateTypes, text: countryText }


                this.setState({ choosen, countryStatesSummery }, () => {
                    this.changeValue()
                })

                this.statesModal.hideModal()


            }

        }

    }

    selectAllTempStates = () => {

        // console.log("selectAllTempStates")
        let tempSelectedStates = {}
        let currentCountry = this.state.currentCountry

        // console.log(currentCountry)

        let countryStates = this.state.countryStates[currentCountry?.country]

        // console.log(countryStates)
        if (Array.isArray(countryStates)) {

            countryStates.forEach(state => {
                tempSelectedStates[state._id] = true
            });

            this.setState({ tempSelectedStates })
        }

    }




    render() {

        let colors = this.props.colors


        return (
            <>
                <div ref={el => this.currentNode = el} className='mt-0 w-100 h-100 flexc' style={{ position: 'relative' }} onClick={() => { this.toggleOpen(true) }} >
                    {/* <div ref={ref => this.setWrapperRef(ref)} className='mt-0 w-100 h-100 flexc' style={{ position: 'relative' }} onClick={() => this.toggleOpen(true)} > */}


                    {this.props.header.information.placeholder && !this.state.choosen?.length && (
                        <div className="h-100 flexc w-100 " style={{ top: 0, padding: '2px 0px 3px 0px' }}>
                            {/* <span style={{ opacity: 0 }}>0</span> */}
                            <label className={' mrd-1 mld-1 placeholder w-100 py-1'}>{checkTextTranslation(this.props.header.information.placeholder)}</label>
                        </div>
                    )}

                    <div className="wrapper w-100"  >
                        <div style={{ flexWrap: 'wrap', borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            {this.state.choosen.map((prop, index) => {
                                return (
                                    <div key={index} className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                        <div className="flexcc" key={index} style={{ padding: 5, backgroundColor: '#eee', borderRadius: 20, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>

                                            <button onClick={(e) => { e.stopPropagation(); this.changeItem(prop, true, null, true) }} className="br-20 p-1 flexcc mrd-1" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                                                <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} />
                                            </button>


                                            <div className="flexc" style={{ flexWrap: 'nowrap', whiteSpace: 'nowrap', marginRight: 2, marginLeft: 2, fontSize: 13, color: '#202020' }}>
                                                {prop.image}
                                                <span className="mld-2">{checkTranslation(prop.title)}</span>
                                                {this.state.isLoadingStates[prop.country] ? (
                                                    <div className="flexcc mld-2 loader-container">
                                                        <Loader
                                                            type="Oval"
                                                            color="rgba(0,122,255,1)"
                                                            height="14"
                                                            width="14"
                                                        />
                                                    </div>
                                                ) : (
                                                    <button onClick={(e) => this.openStates(e, prop)} className="mld-2 text-link text-smaller">{this.state.countryStatesSummery[prop.country]?.text} - {translate("Edit")}</button>
                                                )}
                                            </div>


                                            {/* <img src="/assets/icons/close.svg" onClick={() => this.removeItem(index)} style={{ padding: 2, paddingLeft: 0, color: '#78b2d0', width: 18, height: 18 }} /> */}
                                        </div>
                                        {/* {index != this.state.choosen.length - 1 && (
                                        <i className="fa fa-arrow-right" style={{ color: '#78b2d0' }}></i>

                                    )} */}
                                    </div>
                                )
                            })}
                            {/* <div className={"position-relative mt-0 mld-1 "}> */}
                            {/* {!this.state.isFinal && (
                                <input ref={'input'} value={this.state.title} onFocus={() => { this.toggleOpen() }} onInput={event => this.search(event.target.value)} onChange={e => { this.props.changeValue(this.props.headerkey, e.target.value) }} className='nofocus mediumiransansfont' style={{ backgroundColor: 'transparent', minWidth: 100, width: this.state.title.length * 9, border: 'none' }} />
                            )} */}
                            {this.state.isLoading && (

                                <div style={{ position: 'absolute', top: 0, right: 5 }}>
                                    <Loader
                                        type="Oval"
                                        color="rgba(0,122,255,1)"
                                        height="20"
                                        width="20"
                                    />
                                </div>
                            )}
                            {/* </div> */}
                            {this.state.isFinal && (<i className="fa fa-check-circle mld-1" style={{ color: '#78b2d0', fontSize: 20 }}></i>)}

                        </div>

                        <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={0} zIndex={15} xOffset={-5} maxWidth={300} rightAlign={false}>

                            <div style={{ display: 'flex', width: '100%', maxWidth: 300, zIndex: 40 }}>
                                <div className={'search-drop-down   py-1 pb-2'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderColor: '#eee', borderRadius: 6, maxHeight: 250, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.2)' }}>
                                    {this.props.header.information.isSearchable && (
                                        <input onChange={event => this.search(event.target.value)} placeholder={translate("Search country ...")} style={{ fontSize: 14, alignSelf: 'stratch', padding: 5, height: 35, backgroundColor: '', border: '0px', borderBottom: '1px solid #eee' }} className={'text-start text-semibold px-3'} />
                                    )}

                                    {this.state.options.map((prop, index) => {
                                        let selected = false
                                        for (var i = 0; i < this.state.choosen.length; i++) {

                                            if (prop.value == this.state.choosen[i].value)
                                                selected = true
                                        }
                                        return (
                                            <div key={index} onClick={() => this.changeItem(prop, selected)} className=" py-2 px-3 cursor-pointer  flexc" style={{ backgroundColor: selected ? '#78b2d030' : '#fff', borderBottom: '1px solid #fff' }}>
                                                <p className="main-c2 text-normal mrd-2" style={{}}>{prop.image}</p>
                                                <p className="main-c2 font-size-14" style={{}}>{checkTranslation(prop.title)}</p>
                                            </div>
                                        )
                                    })}

                                    {this.state.options.length == 0 && (
                                        <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                            <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                            {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}

                                        </div>
                                    )}

                                </div>
                            </div>
                        </FixedView>
                        {/* )} */}

                    </div>

                </div >


                <Modal ref={el => this.statesModal = el} maxWidth={400}>
                    <div className="d-flex flex-column  bg-white br-15" >
                        <div className="flexcb   px-3 pt-2 pb-2" style={{ borderBottom: '1px solid #eee', position: 'sticky', top: 0 }}>
                            <div className="flexc" >
                                <div>
                                    <p className="text-big">{this.state.currentCountry?.image}</p>
                                </div>
                                <div className="mld-3">
                                    <p className="text-bold">{this.state.currentCountry?.title} <span className="text-smaller">{translate("Choose regions")}</span></p>

                                </div>

                            </div>
                            <div>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { this.submitCurrentStates() }}
                                    title={translate('Done')}
                                    textColor={colors?.primaryColor ?? '#fff'}
                                    bg={colors?.background ?? '#007aff'}
                                    width={'100%'}
                                />
                            </div>
                        </div>

                        <div className="pt-3 pb-3 px-3">
                            {this.state.countryStates && this.state.countryStates[this.state.currentCountry?.country] && this.state.countryStates[this.state.currentCountry?.country]?.map((state, index) => {
                                let selected = false
                                if (this.state.tempSelectedStates && this.state.tempSelectedStates[state._id]) {
                                    selected = true
                                }
                                return (
                                    <button className="flexc mb-3" onClick={() => this.changeCurrentTempStates(state, selected)}>

                                        <label className="checkbox-container " style={{ pointerEvents: 'none' }} >
                                            <input type="checkbox" checked={selected} />
                                            <span className="checkmark"></span>
                                        </label>
                                        <div className="mld-3">
                                            <p className="text-semibold text-small">{state.name}</p>
                                        </div>
                                    </button>
                                )
                            })}

                        </div>

                        <div className="flexc px-3 pb-2 pt-2" style={{ position: 'sticky', bottom: 0, borderTop: '1px solid #eee' }}>

                            <button className="text-link text-small" onClick={() => this.selectAllTempStates()}>
                                {translate("Select All")}
                            </button>

                            <button onClick={() => this.setState({ tempSelectedStates: {} })} className="text-link mld-4 text-small">
                                {translate("Deselect All")}
                            </button>
                        </div>


                    </div>
                </Modal>

            </>
        );
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(RegionsInput);